import React, {Component} from "react";
import LocalState from "../components/where-to-buy/wtb-local.jsx";
import NationalOrOnlineState from "../components/where-to-buy/wtb-nation-online.jsx";
import Geocode from "react-geocode";
import {googleApiKey} from "../../config.json";
import InternationalState from "../components/where-to-buy/wtb-international.jsx";
import WtbInitial from "../components/where-to-buy/wtb-initial.jsx";
import {getUrlParams} from "../../utils/index.js";
import WTBCalls from '../components/where-to-buy/wtb-calls.jsx';
import Magnific from '../components/magnific.jsx';

class WhereToBuy extends WTBCalls {
    constructor(props) {
        super(props);
        this.state = {
            nodeId: props.id,
            center: {
                lat: 43.03,
                lng: -88.03
            },
            zoom: 10,
            city: "",
            state: "",
            zipcode: "",
            distance: "50",
            dealers: [],
            error: false,
            loading: false,
            firstLoad: true,
            dealerList: [],
            category1: true,
            category2: true,
            userLat: 0.0,
            userLng: 0.0,
            showLink: false,
            eventTarget: 0,
            prevLat: 0.0,
            prevLng: 0.0,
            searchType: "",
            searchTypeName: "",
            errorMsg: props.errorMsg,
            errorBtn: props.errorBtn,
            country: "",
            countries: [],
            initialLoad: true,
            parentPath: "",
            salesReps: [],
            distributors: [],
            useDistributors: props.useDist === "True",
            hideLocal: props.local === "True",
            hideNational: props.national === "True",
            hideIntl: props.intl === "True",
            hideOnline: props.online === "True",
            hideServingSystemSales: props.servingSystemSales === "True",
            hideProductSales: props.productSales === "True",
            localText: props.localText,
            internationalText: props.internationalText,
            servingSystemSalesText: props.servingSystemSalesText,
            productSalesText: props.productSalesText,
            localUrl: props.localUrl,
            internationalUrl: props.internationalUrl,
            servingSystemSalesUrl: props.servingSystemSalesUrl,
            productSalesUrl: props.productSalesUrl,
            pushState: true,
            showModal: false,
            modalIndex: 0,
            submitForm: false,
            videoItems: []
        };
        this.checkboxChange = this.checkboxChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChangeDistance = this.onChangeDistance.bind(this);
        this.categoryCompare = this.categoryCompare.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.userPosition = this.userPosition.bind(this);
        this.apiCall = this.apiCall.bind(this);
        this.loadNationalDealers = this.loadNationalDealers.bind(this);
        this.loadOnlineDealers = this.loadOnlineDealers.bind(this);
        this.loadCountries = this.loadCountries.bind(this);
        this.onLinkChange = this.onLinkChange.bind(this);
        this.setPrevStateItems = this.setPrevStateItems.bind(this);
        this.searchTypeChange = this.searchTypeChange.bind(this);
        this.getUrl = this.getUrl.bind(this);
        this.onChangeCountry = this.onChangeCountry.bind(this);
        this.onClick = this.onClick.bind(this);
        this.handleVideoClick = this.handleVideoClick.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);

    }

    get galleryItems() {
        return this.state.videoItems.map(v => {
            return {
                type: v.Url.indexOf('.mp4') >= 0 && v.Url.indexOf('vollrath.widen') <= 0 ? 'video' : 'iframe',
                src: v.Url,
                description: v.Title,
                id: v.Id
            };
        });
    }

    handleVideoClick(e) {
        e.preventDefault();

        let link = e.target;
        while (link.tagName !== 'A') {
            link = link.parentElement;
        }
        const linkId = link.getAttribute('data-index');
        console.log(link);
        const videoIndex = this.galleryItems.findIndex(g => g.id === parseInt(linkId));
        this.setState({
            showModal: true,
            modalIndex: videoIndex
        });
    }

    handleModalClose() {
        this.setState({
            showModal: false
        });
    }

    //onchange event
    onChange(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    //submit form on distance change after first load
    onChangeDistance(e) {
        this.setState({[e.target.name]: e.target.value, showLink: false}, () => {
            if (!this.state.firstLoad) {
                history.pushState(null, document.title, this.getUrl());
                this.apiCall();
            }
        });
    }

    //international select box submit logic handle
    onChangeCountry(e) {
        this.setState({[e.target.name]: e.target.value}, () => {
            this.loadInternationalDealers();
        });
    }

    //map zoom and center change
    _onChange({center, zoom}) {
        this.setState({
            center,
            zoom
        });
    }

    //search type checkbox logic handle
    onClick(e) {
        e.preventDefault();

        const url = e.currentTarget.href;
        let query = url.substr(url.lastIndexOf("?"));
        query = query.substr(1).substr(query.lastIndexOf("="));
        history.pushState(null, document.title, this.getUrl());
        this.setState({
            searchType: query,
            initialLoad: false
        }, () => {
            switch (this.state.searchType) {
                case "local":
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(this.userPosition);
                    }
                    document.getElementById("local").checked = true;
                    break;
                case "national":
                    this.loadNationalDealers();
                    document.getElementById("national").checked = true;
                    break;
                case "online":
                    this.loadOnlineDealers();
                    document.getElementById("online").checked = true;
                    break;
                case "international":
                    if (!this.state.firstLoad && this.state.country !== "") {
                        this.loadInternationalDealers();
                    } else {
                        history.pushState(null, document.title, this.getUrl());
                    }
                    document.getElementById("international").checked = true;
                    break;
            }
        });
    }

    //info box show or not logic
    onLinkChange(e) {
        e.persist();
        this.setState(prevState => ({
            showLink: !prevState.showLink,
            eventTarget: e.target.innerText
        }));
    }

    //sets previous lat/lng
    setPrevStateItems() {
        this.setState(prevState => ({
            prevLat: prevState.userLat,
            prevLng: prevState.userLng
        }));
    }

    //method for category checkbox changes
    checkboxChange(e) {
        this.setState({[e.target.name]: e.target.checked});
    }

    //checks if category checkbox is checked or not
    categoryCompare(category) {
        let categoryState;

        switch (category) {
            case "category1":
                categoryState = this.state.category1;
                break;
            case "category2":
                categoryState = this.state.category2;
                break;
        }
        return categoryState;
    }

    //submit form
    onSubmit(e) {
        e.preventDefault();
        this.setState({showLink: false});

        this.setState({submitForm: true}, () => {
            console.log(this.state.submitForm)
            this.apiCall();
        })
    }

    //load countries on mount for select box
    componentDidMount() {
        this.loadCountries();
        let params = getUrlParams();
        let type, city, state, zip, distance, country;
        !params.type ? (type = "") : (type = params.type);
        !params.city ? (city = "") : (city = params.city);
        !params.state ? (state = "") : (state = params.state);
        !params.zipcode ? (zip = "") : (zip = params.zipcode);
        !params.distance ? (distance = "50") : (distance = params.distance);
        !params.country ? (country = "") : (country = params.country);

        window.addEventListener("popstate", e => {
            params = getUrlParams();
            !params.type ? (type = "") : (type = params.type);
            !params.city ? (city = "") : (city = params.city);
            !params.state ? (state = "") : (state = params.state);
            !params.zipcode ? (zip = "") : (zip = params.zipcode);
            !params.distance ? (distance = "50") : (distance = params.distance);
            !params.country ? (country = "") : (country = params.country);
            this.setState({
                searchType: type,
                country: country,
                initialLoad: false,
                salesReps: [],
                city: city,
                state: state,
                zipcode: zip,
                distance: distance,
                dealers: [],
                showLink: false,
                error: false,
                loading: false,
                firstLoad: true,
                dealerList: []
            }, () => {
                switch (this.state.searchType) {
                    case "local":
                        if (city === "" && zip === "") {
                            if (navigator.geolocation) {
                                navigator.geolocation.getCurrentPosition(this.userPosition);
                            }
                        }
                        this.apiCall(false);
                        //document.getElementById("local").checked = true;
                        break;
                    case "national":
                        this.loadNationalDealers(false);
                        document.getElementById("national").checked = true;
                        break;
                    case "online":
                        this.loadOnlineDealers(false);
                        document.getElementById("online").checked = true;
                        break;
                    case "international":
                        this.loadInternationalDealers(false);
                        //document.getElementById("international").checked = true;
                        break;
                    case "":
                        this.setState({initialLoad: true});
                        break;
                }
            });
        });
        this.setState({
            searchType: type,
            country: country,
            initialLoad: false,
            salesReps: [],
            city: city,
            state: state,
            zipcode: zip,
            distance: distance,
            dealers: [],
            error: false,
            showLink: false,
            loading: false,
            firstLoad: true,
            dealerList: []
        }, () => {
            switch (this.state.searchType) {
                case "local":
                    if (city === "" && zip === "") {
                        if (navigator.geolocation) {
                            navigator.geolocation.getCurrentPosition(this.userPosition);
                        }
                    }
                    this.apiCall();
                    //document.getElementById("local").checked = true;
                    break;
                case "national":
                    this.loadNationalDealers();
                    document.getElementById("national").checked = true;
                    break;
                case "online":
                    this.loadOnlineDealers();
                    document.getElementById("online").checked = true;
                    break;
                case "international":
                    this.loadInternationalDealers();
                    //document.getElementById("international").checked = true;
                    break;
            }
            if (this.state.searchType === "") {
                this.setState({initialLoad: true});
            }
        });
    }

    //logic for changing search type
    searchTypeChange(e) {
        this.setState({
            center: {
                lat: 43.03,
                lng: -88.03
            },
            zoom: 10,
            city: "",
            state: "",
            zipcode: "",
            distance: "50",
            dealers: [],
            error: false,
            loading: false,
            firstLoad: true,
            dealerList: [],
            category1: true,
            category2: true,
            userLat: 0.0,
            userLng: 0.0,
            showLink: false,
            eventTarget: 0,
            prevLat: 0.0,
            prevLng: 0.0,
            searchTypeName: e.target.value,
            searchType: e.target.id,
            country: "",
            initialLoad: false,
            salesReps: [],
            pushState: true
        }, () => {
            switch (this.state.searchType) {
                case "local":
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(this.userPosition);
                    } else {
                        history.pushState(null, document.title, this.getUrl());
                    }
                    break;
                case "national":
                    this.loadNationalDealers();
                    break;
                case "online":
                    this.loadOnlineDealers();
                    break;
                case "international":
                    if (!this.state.firstLoad && this.state.country !== "") {
                        this.loadInternationalDealers();
                    } else {
                        history.pushState(null, document.title, this.getUrl());
                    }
                    break;
            }

            if (this.state.searchType === "") {
                this.setState({initialLoad: true});
            }
        });
    }

    //get current window url
    getUrl() {
        return `${window.location.pathname}${
            this.state.searchType !== "" ? "?type=" : ""
        }${this.state.searchType}${this.state.country !== "" ? "&country=" : ""}${
            this.state.country
        }${this.state.city !== "" ? "&city=" : ""}${this.state.city}${
            this.state.state !== "" && this.state.searchType === "local"
                ? "&state="
                : ""
        }${this.state.searchType === "local" ? this.state.state : ""}${
            this.state.zipcode !== "" ? "&zipcode=" : ""
        }${this.state.zipcode}${
            this.state.distance !== "" && this.state.searchType === "local"
                ? "&distance="
                : ""
        }${this.state.searchType === "local" ? this.state.distance : ""}`;
    }

    //get user position from browser api
    userPosition(position) {
        let postalCode, locality, adminArea;

        Geocode.setApiKey(googleApiKey);
        Geocode.fromLatLng(
            position.coords.latitude,
            position.coords.longitude
        ).then(
            response => {
                const addressComponents = response.results[0].address_components;

                if (addressComponents) {
                    postalCode = addressComponents.filter(
                        item => item.types[0] === "postal_code"
                    );
                    locality = addressComponents.filter(
                        item =>
                            item.types[0] === "locality" || item.types[0] === "sublocality"
                    );
                    adminArea = addressComponents.filter(
                        item => item.types[0] === "administrative_area_level_1"
                    );

                    this.setState(
                        {
                            zipcode: postalCode[0].short_name,
                            city: locality[0].short_name,
                            state: adminArea[0].long_name,
                            userLat: position.coords.latitude,
                            userLng: position.coords.longitude
                        }, () => {
                            if (this.state.pushState) {
                                this.apiCall();
                            } else {
                                this.apiCall(false);
                            }
                        });
                }
            },
            error => {
                console.log(error);
            });
    }


    //render method
    render() {
        let currentState;
        const state = this.state;
        let searchTypeView;
        
        if (this.state.initialLoad) {
            searchTypeView = <WtbInitial onClick={this.onClick} state={state}/>;
        }

        switch (this.state.searchType) {
            case "local":
                currentState = (
                    <LocalState
                        state={state}
                        categoryCompare={this.categoryCompare}
                        checkboxChange={this.checkboxChange}
                        onLinkChange={this.onLinkChange}
                        onChangeDistance={this.onChangeDistance}
                        onChange={this.onChange}
                        onSubmit={this.onSubmit}
                        _onChange={this._onChange.bind(this)}
                        onVideoClick={this.handleVideoClick}
                    />
                );
                break;
            case "national":
            case "online":
                currentState = <NationalOrOnlineState state={state}/>;
                break;
            case "international":
                currentState = (
                    <InternationalState
                        state={state}
                        categoryCompare={this.categoryCompare}
                        checkboxChange={this.checkboxChange}
                        onLinkChange={this.onLinkChange}
                        onChangeCountry={this.onChangeCountry}
                        onChange={this.onChange}
                        onSubmit={this.onSubmit}
                        _onChange={this._onChange.bind(this)}
                        onVideoClick={this.handleVideoClick}
                    />
                );
                break;
        }

        //what renders to the dom
        return (
            <div>
                <div>
                    {searchTypeView}
                </div>
                {currentState}
                <Magnific items={this.galleryItems} show={this.state.showModal} onClose={this.handleModalClose}
                          index={this.state.modalIndex}/>
            </div>
        );
    }
}

export default WhereToBuy;
